import { ChainId } from '../chainId';
import { constructSameAddressMap } from '../utils/constructSameAddressMap';

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000'

type AddressMap = { [chainId: number]: string }

export const FACTORY_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x1F98431c8aD98523631AE4a59f267346ea31F984', [
    ChainId.OPTIMISM,
    ChainId.OPTIMISTIC_KOVAN,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_RINKEBY,
  ]),
  [ChainId.RINKEBY]: '0xd60ccFdf97985c2920d8E734c6352Aec85A9a4f3',
  [ChainId.BSC_TESTNET] : '0x583A2A380c2059CB7305376c9B865e8624F85c03',
  [ChainId.INDRA_TESTNET] : '0x627DB929F25413c2A055Cb505f15071652248c4C',
}

export const SWAP_ROUTER_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [
    ChainId.OPTIMISM,
    ChainId.OPTIMISTIC_KOVAN,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_RINKEBY,
  ]),
  [ChainId.RINKEBY]: '0xe03E40b3b9D16db74cb95D0fFEA7404e91687811',
  [ChainId.BSC_TESTNET] : '0xA734f88987253641511038119c2a26F7F1FA886f',
  [ChainId.INDRA_TESTNET] : '0x968A0C22C4633DcF6385a91bAbf1e1D5564bdD2f',
}

export const MULTICALL_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [ChainId.OPTIMISTIC_KOVAN]),
  [ChainId.RINKEBY]: '0x6A237ddA56FF40505041B1C64f85c586c6F59187',
  [ChainId.OPTIMISM]: '0x90f872b3d8f33f305e0250db6A2761B354f7710A',
  [ChainId.ARBITRUM_ONE]: '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB',
  [ChainId.ARBITRUM_RINKEBY]: '0xa501c031958F579dB7676fF1CE78AD305794d579',
  [ChainId.BSC]: '0xa9193376D09C7f31283C54e56D013fCF370Cd9D9',
  [ChainId.BSC_TESTNET] : '0x6711bA60c0D14641d8FFbB68B1Eb59F2856A9efa',
  [ChainId.INDRA_TESTNET] : '0xE3ec57608D01bEa0A2ca98BA13dE9927FfD95B3f'
}

export const QUOTER_ADDRESSES: AddressMap = {
  ...constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [
    ChainId.OPTIMISM,
    ChainId.OPTIMISTIC_KOVAN,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_RINKEBY,
  ]),
  [ChainId.RINKEBY]: '0x13145BCb93db915E2dBEEDA6F66189778A8B8140',
  [ChainId.BSC_TESTNET] : '0xd28b263494520c694131EEB079ba465DD5B260A4',
  [ChainId.INDRA_TESTNET] : '0xDFeDA4c4210C378364fF27A5E3b934aa0069956D'
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  ...constructSameAddressMap('0xC36442b4a4522E871399CD717aBDD847Ab11FE88', [
    ChainId.OPTIMISM,
    ChainId.OPTIMISTIC_KOVAN,
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_RINKEBY,
  ]),
  [ChainId.RINKEBY]: '0xcEBE22cFD06Aea801B95dd82E832AA164474Aaf3',
  [ChainId.BSC_TESTNET] : '0xb717dd0278be6CFd013839FD6aB701818f2E53a9',
  [ChainId.INDRA_TESTNET] : '0xf610C2DF2972DB6a937A95bB5BAf61cD7DfD18a0'
}

export const MIGRATOR_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0xA5644E29708357803b5A882D272c41cC0dF92B34', [
    ChainId.ARBITRUM_ONE,
    ChainId.ARBITRUM_RINKEBY,
  ]),
  [ChainId.BSC_TESTNET] : '0x02D928A6d9E2eAbf55A91E81CdCaaB408f856AE5',
}

export const BTR_ADDRESS: AddressMap = {
  [ChainId.BSC_TESTNET]: '',
  [ChainId.INDRA_TESTNET]: '0xdd6f2F59dcE938CB3A03c5C1b184dB3AcdCC2057'
}

export const BITRIEL_GOVERNANCE_ADDRESS: AddressMap = {
  [ChainId.BSC_TESTNET]: ''
}

export const TIMELOCK_ADDRESS: AddressMap = {
  [ChainId.BSC_TESTNET]: ''
}

export const BITRIEL_FARM: AddressMap = {
  [ChainId.INDRA_TESTNET]: '0x514fA65817188abDd2cb094AF8c77A3f63AE006B'
}